import React, { memo, useEffect, useState } from "react";
import {
  Card,
  Col,
  Form,
  Row
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useTranslation } from "react-i18next";
import "./index.css";

import { Creators as LoadersActions } from "../../store/ducks/loaders";
import { Creators as VirtualFencesActions } from "../../store/ducks/virtualFences";

import VirtualFenceService from "../../services/VirtualFence";

import FilterVirtualFenceItem from "../FilterVirtualFenceItem";
import SwitchDefault from "../Switch/Default";

/**
 * Versão reduzida (porte B2): busca só por palavra, sem seletor de cliente/ativo.
 * Reaproveita o duck `virtualFences` do vtb (item normalizado `{ id, virtualFence, selected }`).
 */
const FilterVirtualFence = ({
  props: {
    currentUser,
    virtualFences,
    virtualFencesSearch,
    virtualFencesSearchOnlyClient,
    virtualFencesSearchQueryEnabled
  },
  funcs: {
    disableLoader,
    enableLoader,
    searchVirtualFence,
    setVirtualFences,
    setVirtualFencesSelected
  },
  options: {
    filterMultipleVirtualFence,
    filterPreSelected
  }
}) => {
  const { t } = useTranslation();
  const virtualFenceService = new VirtualFenceService();

  const onlyClient = virtualFencesSearchOnlyClient.length ? virtualFencesSearchOnlyClient : virtualFences;

  const [switchAllChecked, setSwitchAllChecked] = useState(false);
  const [switchSingleChecked, setSwitchSingleChecked] = useState(false);
  const [_virtualFencesSelected, _setVirtualFencesSelected] = useState([]);
  const [_word, _setWord] = useState("");

  useEffect(() => {
    findVirtualFences();
  }, []); /* eslint-disable-line */

  useEffect(() => {
    searchVirtualFence({ word: _word });
  }, [_word]); /* eslint-disable-line */

  useEffect(() => {
    if(!switchSingleChecked) {
      if(switchAllChecked) {
        return _setVirtualFencesSelected(onlyClient);
      }
      return _setVirtualFencesSelected([]);
    }
    setSwitchSingleChecked(false);
  }, [switchAllChecked]); /* eslint-disable-line */

  useEffect(() => {
    setVirtualFencesSelected(_virtualFencesSelected);
    if(_virtualFencesSelected.length > 0 && (onlyClient.length === _virtualFencesSelected.length)) {
      return setSwitchAllChecked(true);
    }
    setSwitchAllChecked(false);
  }, [_virtualFencesSelected]); /* eslint-disable-line */

  const findVirtualFences = async () => {
    enableLoader();
    const virtualFencesResponse = await virtualFenceService.findAll({
      data: {
        limit: 1000,
        page: 1,
        search: ""
      },
      token: currentUser.token
    });
    const virtualFencesFilter = (virtualFencesResponse.docs || []).slice();
    setVirtualFences(virtualFencesFilter);
    if(filterPreSelected) {
      _setVirtualFencesSelected(
        filterPreSelected.length === 0 ? (
          virtualFencesFilter
        ) : (
          virtualFencesFilter.filter(x => filterPreSelected.findIndex(y => y === x.id) !== -1)
        )
      );
    }
    disableLoader();
  };

  const handleClickVirtualFence = (e, virtualFence) => {
    if(filterMultipleVirtualFence) {
      return handleClickVirtualFenceMultiple(e, virtualFence);
    }
    return handleClickVirtualFenceSingle(e, virtualFence);
  };

  const handleClickVirtualFenceMultiple = (e, virtualFence) => {
    const virtualFencesSelected = _virtualFencesSelected.filter(x => x.id !== virtualFence.id);
    if(!e) {
      virtualFencesSelected.push(virtualFence);
    }
    setSwitchSingleChecked(true);
    _setVirtualFencesSelected(virtualFencesSelected);
  };

  const handleClickVirtualFenceSingle = (e, virtualFence) => {
    const virtualFencesSelected = [virtualFence];
    setSwitchSingleChecked(true);
    _setVirtualFencesSelected(virtualFencesSelected);
  };

  return (
    <Card>
      <Card.Header>{t("Title.VirtualFence")}</Card.Header>
      <Card.Body>
        <Row>
          <Col>
            <Form.Group controlId="filter-virtual-fence-search-virtualFence">
              <Form.Control
                type="text"
                placeholder={t("Placeholder.Search")}
                autoComplete={"off"}
                onChange={e => {
                  e.persist();
                  _setWord(e.target.value);
                }}
                value={_word}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="filter-virtual-fence-list-all">
              {
                filterMultipleVirtualFence ? (
                  <div className="filter-virtual-fence-select-all">
                    <SwitchDefault title={`${t("Title.All")} (${virtualFencesSearchQueryEnabled ? virtualFencesSearch.length : virtualFences.length})`} selected={switchAllChecked} onClick={e => {
                      setSwitchSingleChecked(false);
                      setSwitchAllChecked(!switchAllChecked);
                    }} />
                  </div>
                ) : null
              }
              <div className="filter-virtual-fence-list-box">
                <ul>
                  {
                    (virtualFencesSearchQueryEnabled ? virtualFencesSearch : virtualFences).map(virtualFence => {
                      const selected = _virtualFencesSelected.find(x => x.id === virtualFence.id) ? true : false;
                      return (
                        <FilterVirtualFenceItem
                          key={`filter-virtual-fence-list-item-${virtualFence.id}`}
                          checkbox={filterMultipleVirtualFence}
                          name={filterMultipleVirtualFence ? `filter-virtual-fence-list-item-${virtualFence.id}` : "filter-virtual-fence-list-item"}
                          virtualFence={virtualFence}
                          selected={selected}
                          onClick={e => handleClickVirtualFence(selected, virtualFence)}
                        />
                      );
                    })
                  }
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

const mapStateToProps = state => ({
  props: {
    currentUser: state.users.currentUser,
    virtualFences: state.virtualFences.virtualFences,
    virtualFencesSearch: state.virtualFences.virtualFencesSearch,
    virtualFencesSearchOnlyClient: state.virtualFences.virtualFencesSearchOnlyClient,
    virtualFencesSearchQueryEnabled: state.virtualFences.virtualFencesSearchQueryEnabled
  }
});

const mapDispatchToProps = dispatch => ({
  funcs: bindActionCreators(Object.assign({}, LoadersActions, VirtualFencesActions), dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(memo(FilterVirtualFence));
